<template>
  <Layout :leftButtonName="$t('문서 메뉴')">
    <template v-if="doc && !doc.pwdExist">
      <template slot="previous">
        <a class="btn btn-icon btn-active-secondary rounded-pill" @click="$go('/doc');">
          <i class="bi bi-chevron-left fs-2hx"></i>
        </a>
      </template>

      <a v-if="device == 'WEB'" slot="toolbar" class="btn btn-secondary" @click="$go('/doc')" v-text="$t('목록으로')" />
      <div slot="top" class="card mb-6" style="padding:1.5rem 2rem">
        <div class="card-header p-0">
          <div class="card-title fw-bold" v-html="doc.docNm + (doc.docNmSub ? ` (${doc.docNmSub})` : '')" />
          <div class="card-toolbar" :title="!doc.editable && $t('등록완료된 문서는 수정이 불가합니다.')">
            <b-button v-if="doc.editable" variant="light-primary" class="me-3"
              @click="action({ action: 'PW 변경', item: doc })">
              <b-icon icon="lock-fill" /> {{ $t('PW 변경') }}</b-button>
            <b-button v-if="auths.includes('MAIN_DOC_UPD')" :disabled="!doc.editable" variant="light-primary" class="me-3"
              @click="action({ action: '수정', item: doc })">
              <b-icon icon="pencil" /> {{ $t('수정') }}</b-button>
            <div v-if="auths.includes('MAIN_DOC_DEL')">
              <b-button v-if="doc.deletable" class="ms-3" variant="danger"
                @click="action({ action: '최근버전 삭제', item: doc, form: { docId: doc.docId } })">
                <b-icon icon="trash" /> {{ $t('최근버전 삭제') }}</b-button>
              <b-button v-else :disabled="!doc.trashable" variant="danger"
                @click="action({ action: '휴지통 이동', item: doc, form: { docId: doc.docId } })">
                <b-icon icon="trash" /> {{ $t('휴지통') }}</b-button>
            </div>
          </div>
        </div>
        <ItemView class="mt-5"
          :items="[{ 버전: doc.currVer, 종류: doc.docTypeNm, 발효일: doc.effectDt.f('date') }, { 파일: { slot: 'file' } }]">
          <div slot="file" @click="onItem">
            <img style="cursor:pointer;height:10rem;margin-right:1rem" :src="$url(doc.thumbUrl)"><a
              class="text-hover-primary" v-text="doc.docFileNmOrigin" />
          </div>
        </ItemView>
      </div>
      <TableView slot="content" @action="action" :actions="['파일보기']" :title="$t('이전 버전')" :list="docVerList"
        min-height="auto" :columns="verColumns" />
      <b-modal v-if="sel && sel.docFileUrl" modal-class="full" id="파일보기" :title="sel.docFileNmOrigin" hide-footer
        centered>
        <b-embed :src="$url(sel.docFileUrl)" allowfullscreen />
      </b-modal>
      <ModalForm @action="action" id="수정" title="문서 수정" :spec="docColumns" :data="doc" />
    </template>

    <template v-if="!doc || doc.pwdExist" slot="sub_title">{{ this.subTitle }}</template>

    <div v-if="!doc || doc.pwdExist" slot="left" class="w-225px">
      <b-button v-if="auths.includes('MAIN_DOC_INS')" class="mb-2" variant="primary" block v-b-modal.추가 v-text="$t('문서 추가')" />
      <MenuView class="mb-3" ref="menuView" @clicked="onMenu"
        :menus="docMenus" />
      <TreeView v-if="auths.includes('MAIN_DOC_DIR_SEL')" class="mb-3" @context="contextTree" @clicked="({ item }) => onTree(item, $t('조직 문서'))" 
        title="조직 문서" labelKey="dirNm" :tree="dirTree" :hasContextMenu="true" />
    </div>
    <TableView v-show="!doc || doc.pwdExist" :keep-page="keepPage" slot="content" 
      :list="list" :server-total="serverTotal" @nextList="getList()"
      :columns="docColumns"
      :filters="device == 'WEB' ? filter : []"
      @action="action"
      :actions="[(auths.includes('MAIN_DOC_VER_ADD') ? '신규버전' : null)]"
      :action-filter="item => item.addableVer"
      :check-actions="[
          (auths.includes('MAIN_DOC_STATUS') ? {text: '등록완료', variant: 'success'} : null), 
          (auths.includes('MAIN_DOC_STATUS') ? {text: '등록취소', variant: 'danger'} : null), 
          (auths.includes('MAIN_DOC_DIR_MOVE') ? {text: '폴더이동', variant: 'secondary'} : null)
      ]">
      <div class="d-flex align-items-center position-relative me-3">
        <b-icon icon="search" />
        <input maxlength="100" id="listSearchKeyword" @change="listParams.searchKeyword = $event.target.value" class="form-control form-control-solid w-200px ps-11" 
          :placeholder="$t('문서명, 파일, 등록자')" :title="$t('문서명, 파일, 등록자')" v-b-tooltip.hover />
      </div>
      <b-button variant="light-primary" v-b-modal.상세>
        <b-icon icon="filter" /> {{ $t('상세') }}
      </b-button>
    </TableView>
    <b-modal id="일괄 폴더이동" size="sm" :title="$t('폴더이동')" @close="getDirId('close')" @cancel="getDirId('cancel')"
      @ok="moveFolder" :ok-title="$t('폴더이동')" :cancel-title="$t('취소')">
      <TreeView @clicked="({ item }) => selFolder = item" radio labelKey="dirNm" :tree="dirTree" />
    </b-modal>
    <ModalForm id="상세" size="sm" @cancel="detailSearch({})" @action="detailSearch" modal-class="border-none"
      :title="$t('발효일')" label-cols="0" ok-title="검색" cancel-title="초기화" :data="detail" form-only
      :spec="[{ type: 'date-between', key: 'effectDt' }]" close-on-backdrop />
    <ModalForm id="PW 변경" @action="action" size="sm" modal-class="border-none" ok-title="저장" form-only label-cols="4"
      :spec="[{ type: 'password', validate: f => f.docPwd != f.docPwd2 && '비밀번호가 일치하지 않습니다.', label: 'PW', key: 'docPwd' }, { type: 'password', label: 'PW 확인', key: 'docPwd2' }]" />
    <ModalForm @action="action" id="추가" title="문서 추가" :spec="docColumns" />
    <ModalForm @action="action" id="신규버전" title="신규버전 추가" ok-title="저장" :spec="docColumns" :data="sel" />
    <ModalForm id="dirModal" size="sm" modal-class="border-none" label-cols="0" :data="dirModal.data"
      @action="({ form }) => contextTreeAction(dirModal.act, dirModal.item, form)" :title="dirModal.title" form-only
      :spec="[{ placeholder: '폴더명', key: 'dirNm' }]">
      <div class="mb-3 gray-txt" v-html="`${this.$t('대상폴더명')}: ${dirModal.item && dirModal.item.dirNm}`" />
    </ModalForm>
    <b-modal id="dirGrp" centered :ok-title="$t('저장')" @ok="insertDocDirGrp()" :cancel-title="$t('취소')" size="sm"
      :title="dirModal.title" :hide-footer="!dirModal.act">
      <div v-if="!dirModal.act">
        <div class="mb-3 gray-txt" v-html="`${this.$t('대상폴더명')}: ${dirModal.item && dirModal.item.dirNm}`" />
        <table style="width:100%">
          <tr v-for="(grp, i) in dirModal.data" :key="i">
            <td v-text="grp.grpNm" />
            <td width="60"><span @click="insertDocDirGrp(grp)" class="btn btn-sm btn-light-primary right"
                v-text="$t('삭제')" />
            </td>
          </tr>
        </table>
      </div>
      <TreeView v-else @clicked="dirGrpToggle" check labelKey="grpNm" :tree="dirModal.data" />
    </b-modal>
    <b-modal id="순서변경" centered scrollable hide-footer @ok="setTree(true)" size="sm" :title="$t('폴더 순서변경')" ok-only
      :ok-title="$t('확인')">
      {{ $t('드래그하여 순서조정') }}
      <draggable class="dir-sibling" v-model="dirSibling" @change="contextTreeAction('순서변경')" v-bind="dragOptions">
        <div :key="i" v-for="(dir, i) in dirSibling">
          {{ dir.dirNm }}<b-icon icon="arrows-move" />
        </div>
      </draggable>
    </b-modal>
  </Layout>
</template>

<script>
import draggable from 'vuedraggable';
import Layout from "@/components/layout/Layout.vue";
import MenuView from "@/components/MenuView.vue";
import TreeView from "@/components/TreeView.vue";
import TableView from "@/components/TableView.vue";
import ModalForm from "@/components/ModalForm.vue";
import ItemView from "@/components/ItemView.vue";
const required = true;

export default {
  components: { draggable, Layout, MenuView, TreeView, TableView, ModalForm, ItemView },
  computed: {
    auths() { return this.$store.state.user.auths || [] },
    dragOptions() { return { animation: 250, ghostClass: "ghost" }; },
    device() { return this.$getDevice(); },
  },
  data: () => ({
    docMenus: [
      { icon: 'stack', label: '전체 문서', key: 'all' }, 
      { icon: 'trash', label: '휴지통', key: 'trash', color: 'danger' }
    ],
    subTitle: '', docDirList: [],
    keepPage: false, serverTotal: 0, filter: [{key:'statusCd', label:'상태', cd: 'DOC_STATUS'}],
    dirTree: [], list: [], sel: null, selVer: null, selFolder: null, doc: null, docVerList: [],
    detail: { effectDt: ['', ''] }, dirModal: {}, dirSibling: [], getDirIdRes: null,
    listParams: { mode: 'all', dirId: '', statusCd: null, searchKeyword: '', effectDtFrom: '', effectDtTo: '' },
    verColumns: [
      { label: '버전', key: 'ver', style: { textAlign: 'center' } },
      { label: '파일', key: 'docFileNmOrigin' },
      { label: '등록자', renderer: r => r.modUserNm + (r.modUserId == 0 ? '' : `<br>(${r.modUserId})`), style: { textAlign: 'center' } },
      { label: '최종등록일', key: 'modDt', type: 'datetime-local', style: { textAlign: 'center' } },
      { label: '발효일', key: 'effectDt', type: 'date', style: { textAlign: 'center' } },
    ],
    docColumns: [
      { label: '상태', width: '125px', key: 'statusNm', renderer: r => `<b class="badge badge-light-${r.statusClass}">${r.statusNm}</b>`, style: { textAlign: 'center' } },
      { label: '종류', required, hide: ['수정', '추가'], readonly: ['신규버전'], form: 1, key: 'docTypeNm', style: { textAlign: 'center' } },
      { label: '종류', hide: ['td', '신규버전'], form: 2, options: [{ text: '내부문서', value: 1 }, { text: '대외문서', value: 2 }], default: 1, key: 'docType', type: 'radio' },
      { label: '버전', hide: ['수정'], readonly: ['추가', '신규버전'], form: 2, default: '1.0', key: 'currVer', style: { textAlign: 'center' } },
      { label: '문서명', renderer: (r, s) => `${r.docNm}${r.pwdExist ? `<i class="bi bi-lock-fill text-primary ms-2"></i>` : ''}${r.docNmSub ? `<br>(${r.docNmSub})` : ''}` },
      { label: '파일', key: 'docFileNmOrigin' },      
      { label: '발효일', required, form: 6, key: 'effectDt', type: 'date', style: { textAlign: 'center' } },
      { label: '등록자\n등록일', renderer: r => `${r.modUserNm}${r.modUserId != 0 && ` (${r.modUserId})` || ''}<br>${r.modDt.f('datetime-local')}`, style: { whiteSpace: 'nowrap', textAlign: 'center' } },
      { label: '등록자', key: 'modUserNm', hide: ['td'] },
      { label: 'PW', validate: f => f.docPwd != f.docPwd2 && '비밀번호가 일치하지 않습니다.', hide: ['td', '수정', '신규버전'], form: 7, key: 'docPwd', type: 'password' },
      { label: 'PW 확인', hide: ['td', '수정', '신규버전'], form: 7.1, key: 'docPwd2', type: 'password' },
      { label: '문서 설명', hide: ['td', '신규버전'], form: 5, key: 'description', type: 'textarea' },
      { label: '문서명', required, hide: ['td'], readonly: ['신규버전'], form: 3, key: 'docNm' },
      { label: '문서명 보조', hide: ['td'], readonly: ['신규버전'], form: 4, key: 'docNmSub' },
      { label: 'PDF 추가', required, hide: ['td', '수정'], form: 8, key: 'docFile', type: 'file', accept: '.pdf' },
      { label: 'PDF 추가', hide: ['td', '추가', '신규버전'], form: 8, key: 'docFile', type: 'file', accept: '.pdf' },
    ],
  }),
  created() {
    this.getList();
    this.setTree();
  },
  watch: {
    '$route.query.id': { handler: 'setDoc', immediate: true },
    listParams: { deep: true, handler() { this.getList(true); } },
  },
  methods: {
    detailSearch({ form }) {
      setTimeout(() => document.activeElement.blur(), 500);
      if (form) this.detail.effectDt = form.effectDt;
      const check = this.detail.effectDt.join('');
      if (!form && !check) return;
      else if (!form) this.detail.effectDt = ['', ''];
      else if (form && !check) return this.$alert(this.$t('발효일이 지정되지 않았습니다.'));
      else if (form && form.effectDt[0] && form.effectDt[1] && form.effectDt[0] > form.effectDt[1]) return this.$alert(this.$t('시작범위가 종료범위보다 큽니다.'));
      this.listParams.effectDtFrom = this.detail.effectDt[0];
      this.listParams.effectDtTo = this.detail.effectDt[1];
    },
    resetSearch() {
      Object.assign(this.listParams, { mode: 'all', dirId: '', statusCd: null, searchKeyword: '', effectDtFrom: '', effectDtTo: '' });
      Object.assign(this.detail.effectDt, ['', '']);
      document.querySelector('#listSearchKeyword').value = '';
    },
    onMenu(menu) {
      this.resetSearch();
      this.listParams.mode = menu.key;
      this.listParams.dirId = '';
    },
    onTree(dir, dirNm) {
      if (dir) {
        if (!dir.dirId) return;
        
        this.resetSearch();
        this.listParams.mode = 'dir';
        this.listParams.dirId = dir.dirId;
      }
      else {
        this.dirModal = {
          data: {}, title: '하위폴더 추가', act: 'insert', item: { dirNm, dirId: 0 }
        };
        this.$bvModal.show('dirModal');
      }
    },
    async setTree(resetCache) {
      if(this.auths.includes('MAIN_DOC_DIR_SEL')) {
        this.dirTree = [];
        const list = await this.$tree('main/doc/selectDocDirList', {}, resetCache);
        for (const dir of list) {
          this.docDirList.push({...dir});
          if (dir.pDirId > 0) list.find(d => d.dirId == dir.pDirId).children.push(Object.assign(dir, { children: [] }));
          else this.dirTree.push(Object.assign(dir, { children: [] }));
        }
      }
    },
    async insertDocDirGrp(grp) {
      this.$bvModal.hide('dirGrp');
      if (!(await this.$alert(grp ? this.$t('[$] 배정된 그룹에서 삭제하시겠습니까?', [grp.grpNm]) : this.$t('배정정보를 저장하시겠습니까?'), { confirm: true }))) return;
      this.$alert((await this.$api('main/doc/dir/insertDocDirGrp', { dirId: this.dirModal.item.dirId, grpIds: this.dirModal.grpIds || this.dirModal.data.filter(d => d != grp).map(d => d.grpId) })).msg);
    },
    dirGrpToggle({ item, evt: { target: el } }) {
      if (el.tagName != 'INPUT') return;
      if (el.checked && !this.dirModal.grpIds.includes(item.grpId)) this.dirModal.grpIds.push(item.grpId);
      else if (!el.checked && this.dirModal.grpIds.includes(item.grpId)) this.dirModal.grpIds = this.dirModal.grpIds.filter(i => i != item.grpId);
    },
    async contextTreeAction(act, item, form) {
      if (act == '순서변경') {
        let newSort;
        this.dirSibling.some((dir, i) => {
          if (dir.sort == i + 1) return;
          else if (dir.sort == i + 2) {//뒤쪽에서 찾아야함
            let j = i + 1;
            while (this.dirSibling[j].sort != i + 1) j++;
            item = this.dirSibling[j];
            newSort = j + 1;
          }
          else {// 자신이 옮겨짐
            item = dir;
            newSort = i + 1;
          }
          return true;
        })
        const res = await this.$api('main/doc/dir/changeDocDirSort', { dirId: item.dirId, newSort });
        if (res.success) {
          this.dirSibling.forEach((dir, i) => dir.sort = i + 1);
          this.setTree(true);
          document.querySelectorAll('.toast').forEach((toast) => { toast.remove(); });
          this.$bvToast.toast(res.msg, { variant: 'success', toaster: 'b-toaster-bottom-right', autoHideDelay: 3000, headerClass: 'd-none' });
        } else {
          this.$alert(res.msg);
        }
        return;
      }
      if (!form.dirNm) return this.$alert(this.$t('폴더명을 확인하세요'));
      const res = await this.$api(`main/doc/dir/${act}DocDir`, { dirId: item.dirId, pDirId: item.dirId, dirNm: form.dirNm });
      if (res.success) this.setTree(true);
      else this.$alert(res.msg);
    },
    contextTree({ evt, item, sibling }) {
      this.$store.commit('contextmenu', {
        evt, menu: {
          그룹배정: async () => {
            const { list } = await this.$api('main/doc/dir/selectDocDirGrpList', { dirId: item.dirId });
            const data = [], grpIds = list.filter(g => g.grpAssign).map(g => g.grpId);
            for (const grp of list) {
              if (grp.pGrpId > 0)
                list.find(g => g.grpId == grp.pGrpId).children.push(Object.assign(grp, { checked: grp.grpAssign, children: [] }));
              else data.push(Object.assign(grp, { checked: grp.grpAssign, children: [] }));
            }
            this.dirModal = { data, title: '그룹배정', act: 'insertGrp', item, grpIds };
            this.$bvModal.show('dirGrp');
          }, '배정된 그룹': async () => {
            const data = (await this.$api('main/doc/dir/selectDocDirGrpList', { dirId: item.dirId })).list.filter(g => g.grpAssign);
            if (data.length == 0) return this.$alert('배정된 그룹이 없습니다.');
            this.dirModal = { data, title: '배정된 그룹', item };
            this.$bvModal.show('dirGrp');
          }, 하위폴더추가: () => {
            this.dirModal = { data: {}, title: '하위폴더 추가', act: 'insert', item };
            this.$bvModal.show('dirModal');
          }, 이름변경: () => {
            this.dirModal = { data: { dirNm: item.dirNm }, title: '폴더 이름변경', act: 'update', item };
            this.$bvModal.show('dirModal');
          }, 순서변경: () => {
            if (sibling.length == 1) return this.$alert(this.$t('형제 폴더가 없습니다.'));
            this.dirSibling = sibling;
            this.$bvModal.show('순서변경');
          }, 삭제: async () => {
            if (!(await this.$alert(this.$t('$ 폴더를 삭제하시겠습니까?', [item.dirNm]), { confirm: true }))) return;
            const res = await this.$api('main/doc/dir/deleteDocDir', { dirId: item.dirId });
            if (res.success) this.setTree(true);
            else this.$alert(res.msg);
          }
        }
      });
    },
    onItem(e) {
      if (!['IMG', 'A'].includes(e.target.tagName)) return;
      this.sel = this.doc;
      this.$bvModal.show('파일보기');
    },
    async setDoc(docId) {
      if (!docId) return this.doc = null;
      try {
        let res = {}, times = 0, docPwd;
        while (times++ < 5 && res.code != 1) {
          if ((this.sel && this.sel.pwdExist) || res.code) docPwd = (await this.$matchDocPwd([this.sel || { pwdExist: true, docNm: '', docId }]))[0].docPwd;
          res = await this.$api('main/doc/selectDoc', { docId, docPwd });
          if (res.code!=1) await this.$alert(res.msg);
        }
        if (res.code != 1) throw 'error matchDocPwd';
        this.doc = res.data;
      } catch (e) {
        console.log(e);
        return this.$router.replace('/doc');
      }
      delete this.doc.pwdExist;
      this.docVerList = (await this.$api('main/doc/selectPreDocVerList', { docId })).list;
    },
    async getDirId(evt) {
      if (evt) {
        if (this.selFolder) this.getDirIdRes(this.selFolder.dirId);
        this.getDirIdRes = null;
        this.selFolder = null;
      }
      else if (this.dirTree.length < 1) {
        this.$alert(this.$t('폴더 생성 후 등록하세요'));
        return;
      }
      else return new Promise(res => {
        this.getDirIdRes = res;
        this.$bvModal.show('일괄 폴더이동');
      });
    },
    async moveFolder(evt) {
      if (!this.selFolder) {
        evt.preventDefault();
        return this.$alert(this.$t('폴더를 선택하세요.'));
      }
      if (this.getDirIdRes) return this.getDirId('ok');
      const success = [], fail = [], { list } = await this.$api('main/doc/moveDocToDir', { docIds: this.sel.map(d => d.docId), dirId: this.selFolder.dirId });
      (list||[]).map(({result:r},i)=>{if(r)success.push(this.sel[i].docNm);else fail.push(this.sel[i].docNm);});
      if (success.length) {
        await this.$alert(this.$t('[$] 파일을 [$] 폴더로 이동했습니다.', [success.join(), this.selFolder.dirNm]) + (fail.length ? '<br>' + this.$t('실패한 항목: [$]', [fail.join()]) : ''));
        this.getList(true);
      }
      else this.$alert(this.$t('실패했습니다.'));
    },
    async action({ action, item, form }) {
      if (item) this.sel = item;
      if (['일괄 등록완료', '일괄 등록취소'].includes(action)) {
        let statusReason; window.tmp = v => statusReason = v;
        if (!(await this.$alert(`${this.$t('해당 항목을 $ 처리하시겠습니까?', [action])}<div class="alert_list"><ul><li>${this.sel.map(i => i.docNm).join('</li><li>')}</li></ul></div>
        <textarea maxlength="1000" style="width:100%" onchange="tmp(this.value)" placeholder="${this.$t('비고')}"></textarea>`, { okVariant: action.indexOf('취소') > 0 ? 'danger' : 'success', okTitle: action.slice(3), title: action, confirm: true }))) return;
        const api = action == '일괄 등록완료' ? 'approveDoc' : 'cancelDoc', success = [], fail = [];
        const { list } = await this.$api('main/doc/' + api, { docIds: this.sel.map(d => d.docId), statusReason });
        (list||[]).map(({result:r},i)=>{if(r)success.push(this.sel[i].docNm);else fail.push(this.sel[i].docNm);});
        if (success.length) {
          await this.$alert(this.$t('[$] 문서를 $ 했습니다.', [success.join(), action]) + (fail.length ? '<br>' + this.$t('실패한 항목: [$]', [fail.join()]) : ''));
          this.refreshDoc(item.map(item => item.docId));
        }
        else this.$alert(this.$t('실패했습니다.'));
        return;
      }
      else if (form) {
        if (['휴지통 이동', '최근버전 삭제', 'PW 변경'].includes(action) && !(await this.$alert(this.$t('[$] 문서를 [$] 하시겠습니까?', [this.sel.docNm, action]), { confirm: true }))) return;
        if (form.append) {
          if (action != '추가') form.append('docId', this.sel.docId);
          if (action == '수정' && !form.get('docFile')) form.append('docFileId', this.sel.docFileId);
        }
        else if (!form.docId) form.docId = this.sel.docId;
        if (action == '추가') {
          const id = await this.getDirId();
          if (!id) return;
          form.append('dirId', id);
        }
        const res = await this.$api('main/doc/' + ({ '휴지통 이동': 'moveDocTrash', '최근버전 삭제': 'deleteDoc', 추가: 'insertDoc', 신규버전: 'insertDocNewVer', 수정: 'updateDoc', 'PW 변경': 'changeDocPwd' })[action], form);
        await this.$alert(res.msg);
        if (res.success) {
          this.$go('/doc');
        }
        
        this.getList(true);
        return;
      }
      else if (action == 'view') return this.$go('doc?id=' + this.sel.docId);
      this.selFolder = null;
      if (action == '신규버전')
        this.sel.currVer = (await this.$api('main/doc/selectDocNewVer', { docId: this.sel.docId })).data;
      this.$bvModal.show(action);
    },
    async getList(reset) {
      if (reset === true) this.list = [];
      const {list, parameter:{total}} = await this.$api('main/doc/selectDocList', { ...this.listParams, firstIndex: this.list.length + 1 });
      this.serverTotal = total;
      this.list.push(...list);

      if(this.listParams.dirId) {
        const dirItem = this.docDirList.find(dir => dir.dirId === this.listParams.dirId);
        this.subTitle = dirItem ? dirItem.dirNm : '';
      } else {
        const menuItem = this.docMenus.find(menu => menu.key === this.listParams.mode);
        this.subTitle = menuItem ? menuItem.label : '';
      }
    },
    async refreshDoc(docIds) {
      this.keepPage = true;
      for(let docId of docIds) {
        const selDoc = await this.$api('main/doc/selectDocOne', { docId: docId });
        this.$set(this.list, this.list.findIndex(item => item.docId === docId), selDoc.data);
      }
      this.$nextTick(()=> { this.keepPage = false; });
    }
  },
}
</script>